<!--
Dialog view with support for basic information showing.

@unstable
-->

<div
  class="container-box flex flex-grow flex-col items-center justify-between"
  [style.background-image]="background | encodeURI: 'url' | safeStyle"
>
  <div class="container-inner flex h-full w-full flex-auto flex-col">
    @if (!hideHeader) {
      <div class="header-box flex flex-none gap-16">
        @if (!!logo) {
          <div
            class="zef-logo-image {{ logoType }} zef-medium"
            [style.background-image]="logo | encodeURI: 'url' | safeStyle"
          ></div>
        }
        @if (sourceType) {
          <zef-source-logo [source]="sourceType" [key]="sourceKey" size="medium"></zef-source-logo>
        }
        <div class="flex flex-col">
          <div class="zef-text-h1">
            @if (typeof title === 'string') {
              {{ title }}
            } @else if (title) {
              <ng-container *ngTemplateOutlet="title" />
            }
          </div>
          <div class="zef-text-light zef-text-p2">{{ label }}</div>
        </div>
      </div>
    }

    <div class="content-box flex flex-grow flex-col gap-16">
      @if (!hideContent) {
        <div class="zef-scroll">
          <mat-dialog-content
            class="!flex flex-col gap-16"
            [class.zef-card-z-1]="hideBorder || !!label || !!header || !!content"
            [class.zef-border]="!hideBorder && (!!label || !!header || !!content)"
            [class.no-padding]="noContentPadding"
          >
            @if (header) {
              <div class="zef-text-h3 flex flex-none">
                {{ header }}
              </div>
            }
            @if (content) {
              <div class="content-area flex flex-none flex-col" [ngClass]="type">
                <div [innerHTML]="content | safeHtml"></div>
              </div>
            }
            @if (showInput) {
              <div class="flex flex-none flex-col">
                <mat-form-field>
                  @if (inputIcon) {
                    <mat-icon [ngClass]="iconColorClass" matPrefix>{{ inputIcon }}</mat-icon>
                  }
                  <input
                    matInput
                    [(ngModel)]="inputValue"
                    cdkFocusInitial
                    autoSelect
                    [placeholder]="inputPlaceholder"
                    (keydown.enter)="onInputEnter($event)"
                  />
                  <ng-content select="[dialog-fields]"></ng-content>
                </mat-form-field>
              </div>
            }
            <ng-content select="[dialog-content]" class="flex-none"></ng-content>
          </mat-dialog-content>
        </div>
      }

      <ng-content select="[dialog-contents]" class="flex-none"></ng-content>
    </div>
  </div>

  @if (!hideActions) {
    <mat-dialog-actions
      [class.no-padding]="noActionPadding"
      class="footer-box flex w-full flex-none flex-col gap-8"
      [ngClass]="action || cancel ? 'items-start justify-end' : 'items-start justify-stretch'"
    >
      <div class="w-full">
        <ng-content select="[dialog-tooltips]"></ng-content>
        <div class="flex flex-1 items-center justify-end gap-4">
          <ng-content select="[dialog-actions]"></ng-content>
          @if (cancel) {
            <button mat-raised-button color="secondary" matDialogClose class="close-button" [ngClass]="type">
              <span>{{ cancel }}</span>
            </button>
          }
          @if (action) {
            <button
              mat-raised-button
              class="action-button"
              [color]="getActionColor()"
              [disabled]="disabled || (showInput && !inputValue?.length)"
              [loading]="loading"
              [ngClass]="type"
              (click)="close(action)"
            >
              <span>{{ action }}</span>
            </button>
          }
        </div>
      </div>
      <ng-content select="[dialog-caption]"></ng-content>
    </mat-dialog-actions>
  }

  @if (dialogImage) {
    <div class="dialog-image">
      <ng-container [ngTemplateOutlet]="dialogImage"></ng-container>
    </div>
  }
</div>

<button mat-icon-button matDialogClose [class.shadow]="!!dialogImage"><mat-icon>close</mat-icon></button>
